var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75H8.75C8.08696 6.75 7.45107 7.01339 6.98223 7.48223C6.51339 7.95107 6.25 8.58696 6.25 9.25V24.25C6.25 24.913 6.51339 25.5489 6.98223 26.0178C7.45107 26.4866 8.08696 26.75 8.75 26.75H21.25C21.913 26.75 22.5489 26.4866 23.0178 26.0178C23.4866 25.5489 23.75 24.913 23.75 24.25V9.25C23.75 8.58696 23.4866 7.95107 23.0178 7.48223C22.5489 7.01339 21.913 6.75 21.25 6.75H18.75M11.25 6.75C11.25 6.08696 11.5134 5.45107 11.9822 4.98223C12.4511 4.51339 13.087 4.25 13.75 4.25H16.25C16.913 4.25 17.5489 4.51339 18.0178 4.98223C18.4866 5.45107 18.75 6.08696 18.75 6.75M11.25 6.75C11.25 7.41304 11.5134 8.04893 11.9822 8.51777C12.4511 8.98661 13.087 9.25 13.75 9.25H16.25C16.913 9.25 17.5489 8.98661 18.0178 8.51777C18.4866 8.04893 18.75 7.41304 18.75 6.75M17.5 14.25H14.375C13.8777 14.25 13.4008 14.4475 13.0492 14.7992C12.6975 15.1508 12.5 15.6277 12.5 16.125C12.5 16.6223 12.6975 17.0992 13.0492 17.4508C13.4008 17.8025 13.8777 18 14.375 18H15.625C16.1223 18 16.5992 18.1975 16.9508 18.5492C17.3025 18.9008 17.5 19.3777 17.5 19.875C17.5 20.3723 17.3025 20.8492 16.9508 21.2008C16.5992 21.5525 16.1223 21.75 15.625 21.75H12.5M15 21.75V23M15 13V14.25",
    stroke: "#1E3F76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentact);
export default __webpack_public_path__ + "static/media/paymentact.c668c3a527c010d380063b959cd3e527.svg";
export { ForwardRef as ReactComponent };